<ng-http-loader [filteredHeaders]="['X-Skip-Loader']"></ng-http-loader>
<router-outlet></router-outlet>